import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./index.scss";
import { useTranslation } from "react-i18next";
import imgExpert from "../../../assets/images/conseilcard.png";
import imgObsidian from "../../../assets/images/buzztrackcard1.png";
import imgBright from "../../../assets/images/conseilcard2.png";
import imgSphere from "../../../assets/images/buzztrachcard2.png";
import imgValeur from "../../../assets/images/matoiscard1.png";
import imgValeur1 from "../../../assets/images/matoiscard2.png";
import imgExpert1 from "../../../assets/images/conseilcard11.png";
import imgExpert2 from "../../../assets/images/conseilcard12.png";

export default function CardsStickyParallax() {
  const { t } = useTranslation();

  const cardsData = [
    {
      id: 1,
      theme: "light",
      badges: [t("cards.conseil.badge1"), t("cards.conseil.badge2")],
      title: ["MSIT-", "CONSEIL"],
      img1: {
        image: imgExpert,
        title: t("cards.conseil.title1"),
        text: t("cards.conseil.text1"),
      },
      img2: {
        image: imgBright,
        title: "",
        text: t("cards.conseil.text2"),
      },
      link: "https://msit-conseil.fr/",
    },
    {
      id: 2,
      theme: "light",
      badges: [t("cards.buzz.badge1"), t("cards.buzz.badge2")],
      title: ["BUZZ", "TRACK"],
      img1: {
        image: imgObsidian,
        title: t("cards.buzz.title1"),
        text: t("cards.buzz.text1"),
      },
      img2: {
        image: imgSphere,
        title: "",
        text: t("cards.buzz.text2"),
      },
      link: "https://buzztrack.fr/",
    },
    {
      id: 3,
      theme: "blue",
      badges: [t("cards.matois.badge1"), t("cards.matois.badge2")],
      title: ["MATOIS"],
      img1: {
        image: imgValeur,
        title: t("cards.matois.title1"),
        text: t("cards.matois.text1"),
      },
      img2: {
        image: imgValeur1,
        title: "",
        text: t("cards.matois.text2"),
      },
      link: "",
    },
    {
      id: 4,
      theme: "light",
      badges: [t("cards.spotin.badge1"), t("cards.spotin.badge2")],
      title: ["SPOT'IN FRANCE"],
      img1: {
        image: imgExpert1,
        title: t("cards.spotin.title1"),
        text: t("cards.spotin.text1"),
      },
      img2: {
        image: imgExpert2,
        title: "",
        text: t("cards.spotin.text2"),
      },
      link: "https://spotin-france.fr/",
    },
  ];

  return (
    <section className="cards-section" style={{ width: "100%", backgroundColor: "#0d0d0d", padding: "60px 0" }}>
      <Container>
        <Row className="g-4">
          {cardsData.map((card) => (
            <Col key={card.id} lg={6} md={6} sm={12}>
              <div className={`card__inner theme--${card.theme || "light"}`}>
                <div className="card__header">
                  {card.badges?.map((b, i) => (
                    <span key={i} className="pill">
                      {b}
                    </span>
                  ))}
                </div>

                <div className="card__grid">
                  <div className="card__titleBlock">
                    {card.title.map((line, i) => (
                      <h1 key={i} className="big">
                        <a className="style-a big" href={card?.link}>
                          {line}
                        </a>
                      </h1>
                    ))}
                  </div>

                  <figure className="tile area-imgA">
                    <img src={card.img1.image} alt="image 1" />
                  </figure>
                  <div className="card__text area-textA">
                    <h3>{card.img1.title}</h3>
                    <p>{card.img1.text}</p>
                  </div>

                  <div className="card__text area-textB">
                    <h3>{card.img2.title}</h3>
                    <p>{card.img2.text}</p>
                  </div>
                  <figure className="tile area-imgB">
                    <img src={card.img2.image} alt="image 2" />
                  </figure>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
